const SCALE_DIGITS = 4;
const SCALE = 10n ** BigInt(SCALE_DIGITS);
export function parseCredits(value, options = {}) {
    const normalized = value.trim();
    if (!/^\d+(?:\.\d+)?$/.test(normalized)) {
        if (normalized.startsWith('-'))
            throw new Error('Количество кредитов должно быть положительным');
        throw new Error('Некорректная сумма кредитов');
    }
    const [whole = '0', fraction = ''] = normalized.split('.');
    if (fraction.length > SCALE_DIGITS)
        throw new Error('Допустимо не более 4 знаков после запятой');
    const units = BigInt(whole) * SCALE + BigInt(fraction.padEnd(SCALE_DIGITS, '0') || '0');
    if (units < 0n || (units === 0n && !options.allowZero)) {
        throw new Error('Количество кредитов должно быть положительным');
    }
    return units;
}
export function formatCredits(units) {
    const sign = units < 0n ? '-' : '';
    const absolute = units < 0n ? -units : units;
    const whole = absolute / SCALE;
    const fraction = (absolute % SCALE).toString().padStart(SCALE_DIGITS, '0').replace(/0+$/, '');
    return `${sign}${whole}${fraction ? `.${fraction}` : ''}`;
}
export const CREDIT_SCALE = SCALE;
//# sourceMappingURL=credits.js.map